var render, staticRenderFns
import script from "./contribute-table.vue?vue&type=script&lang=js"
export * from "./contribute-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739b6543",
  null
  
)

export default component.exports